// imports
import Component from 'minsky-kit/js/components/Component';

// private statics
const VERSION = '1.0.0';

const parallaxCfg = [
    { selector: '.views-row > a:first-child', offset: '40px' },
    { selector: '.views-row > a:nth-child(2)', offset: '-60px' },
    { selector: '.views-row > a:nth-child(3)', offset: '20x' },
    { selector: '.views-row > a:nth-child(4)', offset: '60px' },
    { selector: '.hero__scrollcta', offset: '100px' },
];

// class definition
export default class HeroParallax extends Component {
    // constructor
    constructor (args = {}, objectName = 'HeroParallax') {
        args.debug = args.debug || false;
        // super
        super(args, objectName);

        this.init();
    }

    init () {
        parallaxCfg.forEach((cfg) => {
            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger:    document.body,
                    start:      '0px top',
                    end:        `${this.$el.offsetHeight}px top`,
                    scrub:      true,
                },
            });

            timeline.to(this.$el.querySelector(cfg.selector), { y: cfg.offset, duration: 1 });
        });
    }

    // getters & setters
    static get version () { return VERSION; }
}
